<div class="sidenav-secondary">
  <div class="content">
    <figure class="logo-container" *ngIf="logoHref && logoHref.length > 1">
      <img src="{{logoHref}}" class="partner-logo" alt="partner logo" />
    </figure>
    <p *ngIf="user$ | async as user" class="user-name">
      <span *ngIf="secondaryNavBreadcrumb == 'Home'">{{ user.fullName() }}</span> <span [innerHTML]="secondaryNavBreadcrumb | translate"></span>
    </p>
    <nav class="nav-secondary">
      <a *ngFor="let item of navItems$ | async" routerLink="/{{ item.route === 'no-op' ? route.url : routePrefix + item.route }}" routerLinkActive="{{ item.route === 'no-op' ? '' : 'active' }}" [attr.tabindex]="0" [innerHTML]="item.labelId | translate">
      </a>
    </nav>
    <img src="./assets/images/global/Comfort-Zone-Logo.png" alt="Comfort Zone" class="cz-logo" />
  </div>
</div>
